import { createStore } from "vuex";
import trade, { State as TradeState } from "./trade";

export type RootState = {
  trade: TradeState;
};

const store = createStore({
  modules: {
    trade,
  },
});

export default store;
